import React from 'react'
import { cn } from '@/utlis/cn'

interface PageIndicatorProps {
    totalPages: number
    currentPage: number
    className?: string
    onClick?: (page: number) => void
}

export const PageIndicator: React.FC<PageIndicatorProps> = ({ totalPages, currentPage, className, onClick }) => {
    let border = 'border-muse-toplit rounded-[32px]'
    return (
        <div
            style={{ width: `${66 + 8 * (totalPages - 1) * 2}px` }}
            className={cn(
                'flex items-center gap-2 bg-[rgba(255,255,255,0.02)] h-[40px] flex-none justify-center',
                border,
                className
            )}
        >
            {Array.from({ length: totalPages }, (_, index) => (
                <div key={index} className="p-[4px] m-[-4px] cursor-pointer" onClick={() => onClick?.(index)}>
                    <div
                        key={index}
                        className={cn(
                            'relative transition-all duration-1000 ease-in-out cursor-pointer',
                            'before:bg-gradient-to-r before:from-[#FFFFFF22] before:to-[#FFFFFFFF] before:rounded-[10px] before:absolute before:inset-0',
                            index === currentPage
                                ? 'w-[24px] h-[4px]'
                                : 'w-[8px] h-[4px] rounded-[10px] bg-white opacity-20'
                        )}
                    />
                </div>
            ))}
        </div>
    )
}

export default PageIndicator
